import AdminContractorDetails from './AdminContractorDetails';
import AdminContractors from './AdminContractors';


export {
    AdminContractors,
    AdminContractorDetails,
};

export default AdminContractors;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Contractors/index.tsx